var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noDataBox"},[_c('img',{attrs:{"src":require("./nofind.png")}}),_c('p',{staticStyle:{"line-height":"30px","font-size":"16px","color":"#909399"}},[_vm._v(" 暂无数据，请稍后再试 ")])])
}]

export { render, staticRenderFns }